<style scoped>
::v-deep .vs__search {
    width: auto;
}

::v-deep .vs__dropdown-menu {
    z-index: 1002;
}
</style>
<template>
    <div>
        <v-select ref="dropdown" multiple @open="openDropdown" v-model="dropdownModel" :options="options" :inputId="id" @search="search" :selectOnTab="true" />
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed, SetupContext, nextTick } from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { throwIfNonSuccessStatus, fetchXsrf } from "@/lib/fetchHelpers.3";
import { asyncComputed } from "@vueuse/core";
import { useMainStore } from "@/mainStore";
import { GroupNameList } from "@cs/GroupNameList";

export default defineComponent({
    name: "GroupNameList",
    components: {
        "v-select": vSelect,
    },
    props: ["type", "containerCodeData", "schema", "id", "value"],
    setup(props, { emit }: SetupContext) {
        const mainStore = useMainStore();

        const dropdown = ref<InstanceType<typeof vSelect>>(null!);

        const searchResults = ref<string[]>(null!);
        const groupNameListPromise = ref<Promise<GroupNameList>>(null!);

        const possibleOptions = computed(() => {
            return (groupNameList.value?.groups || []).filter(i => !(props.value || []).includes(i));
        });
        const options = computed(() => {
            return searchResults.value || possibleOptions.value.map(k => ({ value: k.Key, label: k.Value }));
        });
        const dropdownModel = computed({
            get: () => props.value,
            set: newVal => {
                emit("input", newVal);
            },
        });

        const groupNameList = asyncComputed(() => groupNameListPromise.value, {});

        const search = async (searchText: string, loadingFunc: (state: boolean) => void) => {
            let _possibleOptions = possibleOptions.value.map(x => x.Value);
            if (_possibleOptions == null) {
                loadingFunc(true);
                await groupNameListPromise.value;
                _possibleOptions = possibleOptions.value.map(x => x.Value);
                loadingFunc(false);
            }
            const lowerSearchText = (searchText || "").toLowerCase();
            const result = _possibleOptions.filter(i => i.toLowerCase().startsWith(lowerSearchText));
            if (!result.some(i => i == searchText) && !/^\s*$/.test(searchText)) {
                result.push(searchText);
            }
            searchResults.value = result;
        };
        const openDropdown = async () => {
            // Set search input's own aria label and required data if no selected option
            dropdown.value.searchEl.closest("[role='combobox']").setAttribute("aria-label", props.schema.Label);
            await nextTick();
            dropdown.value.$el.querySelectorAll("ul").forEach((elem: HTMLElement) => {
                elem.setAttribute("aria-label", props.schema.Label);
            });
        };

        groupNameListPromise.value = (async () => {
            const getUrl = await mainStore.getUrl("adminUserManagementGroupNameList", { containerCode: props.containerCodeData });
            const response = await fetchXsrf(mainStore, getUrl);
            throwIfNonSuccessStatus(response);
            return await response.json();
        })();

        return {
            // Refs
            dropdown,

            options,
            dropdownModel,
            search,
            openDropdown,
        };
    },
});
</script>
